module.exports = "/_next/static/images/036c1987240f2f7f15e78f3ab8e6172b-blog3a-xs.jpg";